"use client";

import clsx from "clsx";
import Button, { type ButtonProps } from "src/components/common/Button/Button";
import Tooltip from "src/components/common/Tooltip/Tooltip";
import styles from "./IconButton.module.scss";

export type IconButtonProps = ButtonProps & {
  labelTooltip?: boolean;
};

const IconButton = (props: IconButtonProps) => {
  const { className, labelTooltip, variant, label, ...otherProps } = props;

  const button = (
    <Button
      label={label}
      className={clsx(styles.iconButton, styles[`variant-${variant ?? "normal"}`], className)}
      variant={variant}
      {...otherProps}
    />
  );

  return labelTooltip === false ? (
    button
  ) : (
    <Tooltip hoverDelay={500}>
      <Tooltip.Reference asChild={true}>{button}</Tooltip.Reference>
      <Tooltip.Content>{label}</Tooltip.Content>
    </Tooltip>
  );
};

export default IconButton;
